<div class="text-center my-4">
    <img src="/assets/icons/something-went-wrong-icon.svg" height="60" class="my-3">

    <h5>{{ 'si_pts_chrome_error_header' | cmsText | async }}</h5>

    <p [appParagraph]="3">{{ 'si_pts_chrome_error_text' | cmsText | async }}</p>

    <a [routerLink]="'/dashboard'" appStandardButton>{{ 'si_pts_chrome_error_back' | cmsText | async }}</a>

</div>
